import React, { useState } from "react";
import PropTypes from "prop-types";

//
import { Card } from "react-bootstrap";
import NumberFormat from "react-number-format";
import Moment from "react-moment";

//
import { iconImage } from "../../redux/features/coins/actions";

//
import ProgressChart from "./ProgressChart";
import ImageBox from "./ImageBox";

function CoinInfoLastAlert({ data, lastAlert }) {
  const convertStatus = (value) => {
    if (value === "won") return "Won";
    if (value === "stopLoss") return "Stoploss";
    if (value === "trendChanged") return "Trend Changed";
    return "Pending";
  };

  const statusColor = (value) => {
    if (value === "won") return "success";
    if (value === "stopLoss") return "danger";
    if (value === "trendChanged") return "muted";
    return "warning";
  };

  /**
   * Convert Data
   * for split and return splited
   */
  const convertValue = (value) => {
    let str = `${value}`;
    let splited = str.split(".");

    return (
      <h4>
        <NumberFormat
          value={splited[0]}
          displayType={"text"}
          prefix={data.symbol === "BTC" ? "$" : "₿"}
          thousandSeparator={true}
          decimalSeparator="."
        />

        {splited[1] && <span>.{splited[1]}</span>}
      </h4>
    );
  };

  return (
    <Card className="h-100 mb-0">
      <Card.Body className="pb-0">
        <div>
          <p className="pair">
            <ImageBox src={iconImage(data.symbol)} />

            <div>
              <span className="text-dark fw-bolder">{data.symbol}</span>
              <i className="las la-sync" />
              <span className="text-dark fw-bolder">
                {data.symbol === "BTC" ? "USD" : "BTC"}
              </span>
            </div>
          </p>

          <div className="price-box">
            <div className="price">
              {convertValue(
                Number(data.price)
                  .toFixed(data.symbol === "BTC" ? 2 : 8)
                  .replace(/\.?0+$/, "")
              )}
              <span
                className={`fw-extra-bolder ${
                  data.percent_change_24h > 0 ? "text-success" : "text-danger"
                }`}
              >
                {data.percent_change_24h.toFixed(2)}
                <i
                  className={`las la-arrow-${
                    data.percent_change_24h > 0 ? "up" : "right"
                  }`}
                />
              </span>
            </div>

            <small>
              <NumberFormat
                value={data.total_supply}
                displayType={"text"}
                thousandSeparator={true}
                decimalSeparator="."
                className="me-1"
              />
              {data.symbol}
            </small>
          </div>

          <ProgressChart
            low={Number(data.low)
              .toFixed(data.symbol === "BTC" ? 2 : 8)
              .replace(/\.?0+$/, "")}
            high={Number(data.high)
              .toFixed(data.symbol === "BTC" ? 2 : 8)
              .replace(/\.?0+$/, "")}
            close={Number(data.close)
              .toFixed(data.symbol === "BTC" ? 2 : 8)
              .replace(/\.?0+$/, "")}
            symbol={data.symbol}
          />
        </div>

        <div className="alert-time">
          <h5>{lastAlert.status === "close" ? "Last" : "Active"} Alert</h5>
          <small className="smaller text-black fw-extra-bolder">
            Time (UTC)
            <span className="mx-1">
              <Moment utc format="hh:mm">
                {lastAlert.reated_at}
              </Moment>
            </span>
            <span>
              (
              <Moment utc fromNow>
                {lastAlert.created_at}
              </Moment>
              )
            </span>
          </small>
        </div>

        <div>
          <div className="market-info">
            <div className="item">
              <small>Action</small>
              <small
                className={`fw-bolder ${
                  lastAlert.action === "BUY" ? "text-success" : "text-danger"
                }`}
              >
                {lastAlert.action}
              </small>
            </div>
            <div className="item">
              <small>Enter Price</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={Number(lastAlert.entry_price)
                    .toFixed(data.symbol === "BTC" ? 2 : 8)
                    .replace(/\.?0+$/, "")}
                  displayType={"text"}
                  prefix={data.symbol === "BTC" ? "$" : "₿"}
                  thousandSeparator={true}
                  decimalSeparator="."
                />
              </small>
            </div>
            <div className="item">
              <small>Target 1</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={Number(lastAlert.target)
                    .toFixed(data.symbol === "BTC" ? 2 : 8)
                    .replace(/\.?0+$/, "")}
                  prefix={data.symbol === "BTC" ? "$" : "₿"}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalSeparator="."
                />
                <i
                  className={`las la-${
                    lastAlert.target_1_hit_at ? "check" : "times"
                  }-circle text-${
                    lastAlert.target_1_hit_at ? "success" : "danger"
                  } ms-1`}
                ></i>
              </small>
            </div>
            <div className="item">
              <small>Target 2</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={Number(lastAlert.target_2)
                    .toFixed(data.symbol === "BTC" ? 2 : 8)
                    .replace(/\.?0+$/, "")}
                  prefix={data.symbol === "BTC" ? "$" : "₿"}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalSeparator="."
                />
                <i
                  className={`las la-${
                    lastAlert.target_2_hit_at ? "check" : "times"
                  }-circle text-${
                    lastAlert.target_2_hit_at ? "success" : "danger"
                  } ms-1`}
                ></i>
              </small>
            </div>
            <div className="item">
              <small>Target 3</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={Number(lastAlert.target_3)
                    .toFixed(data.symbol === "BTC" ? 2 : 8)
                    .replace(/\.?0+$/, "")}
                  prefix={data.symbol === "BTC" ? "$" : "₿"}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalSeparator="."
                />
                <i
                  className={`las la-${
                    lastAlert.target_3_hit_at ? "check" : "times"
                  }-circle text-${
                    lastAlert.target_3_hit_at ? "success" : "danger"
                  } ms-1`}
                ></i>
              </small>
            </div>

            <div className="item">
              <small>Stop Loss</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={Number(lastAlert.stop_loss)
                    .toFixed(data.symbol === "BTC" ? 2 : 8)
                    .replace(/\.?0+$/, "")}
                  prefix={data.symbol === "BTC" ? "$" : "₿"}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalSeparator="."
                />
              </small>
            </div>

            <div className="item">
              <small>Win Status</small>
              <small
                className={`fw-bolder text-${statusColor(
                  lastAlert.win_status
                )}`}
              >
                {convertStatus(lastAlert.win_status)}
              </small>
            </div>

            <div className="item">
              <small>Target Profit</small>
              <small
                className={`fw-bolder ${
                  +lastAlert.max_profit_amount > 0
                    ? "text-success"
                    : "text-danger"
                }`}
              >
                {lastAlert.max_profit_amount}%
              </small>
            </div>

            <div className="item">
              <small>Potential Profit</small>
              <small
                className={`fw-bolder ${
                  +lastAlert.max_market_profit > 0
                    ? "text-success"
                    : "text-danger"
                }`}
              >
                {lastAlert.max_market_profit}%
              </small>
            </div>

            <div className="item">
              <small>Highest/Lowest Price</small>
              <small className="text-black fw-bolder">
                <NumberFormat
                  value={Number(
                    lastAlert.action === "BUY"
                      ? lastAlert.high_market_price
                      : lastAlert.low_market_price
                  )
                    .toFixed(data.symbol === "BTC" ? 2 : 8)
                    .replace(/\.?0+$/, "")}
                  prefix={data.symbol === "BTC" ? "$" : "₿"}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalSeparator="."
                />
              </small>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

CoinInfoLastAlert.propTypes = {
  data: PropTypes.object.isRequired,
  lastAlert: PropTypes.object.isRequired,
};

export default CoinInfoLastAlert;
